/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// convert comma separated values to to pills when user press enter in certifications, experience field

$(document).on('keypress', `#employment_person_certifications, #employment_person_country_of_experience, #employment_person_years_of_experience`, function(e) {

  const code = e.keyCode || e.which;
  if (code === 13) {
    e.preventDefault();
    return $(".tag-link").trigger("click");
  }
});